export default __webpack_public_path__ + "static/media/old_mercs_pal.67aa1930.png";